export function paymentCurrentStateSelector(state) {
  return state.local.payments.current
}
